import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react'
import { snowmindsConfig } from '../../configuration';
import ReactHtmlParser from 'react-html-parser';
import { getgriddata } from '../home/dummyData';

const UmbracoReusableGrid = (props) => {

    const [gridData, setGridData] = useState(null);
    useEffect(() => {
        fetchReusableGridModules();
    }, [])

    const fetchReusableGridModules = () => {
        let snowminds = snowmindsConfig.getSnowMindsConfiguration();
        const url = snowminds.getGridApi.reusableGridApi;

        const pageId = props.pageId;
        const culture = document.getElementById("hdLanguage").value;
        let params = { pageId: pageId, culture: culture };

        //debugger
       // const data = getgriddata();
      //  setGridData(data.HtmlCollection[0]);
        axios.get(url, { params: params }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(res => {
                //(res + `page grid data`)
                if (res.data && res.data.hasOwnProperty("HtmlCollection")) {
                    const { HtmlCollection } = res.data;
                    setGridData(HtmlCollection[0]);
                }
            })
            .catch(err => {
                //(err)

            });


    }
    if (gridData)
        return (
            <div className="static-full-width-content" style={{marginTop:10,marginBottom:10}}>
                <Fragment>
                    {/* <div className="two-col-detail-table" style={{ marginBottom: 55 }}>
                        <h3 style={{ textAlign: "center", display: `block`, marginBottom: 35 }}>Reusable Modules</h3>
                    </div> */}
                    {ReactHtmlParser(gridData)}
                </Fragment>
            </div>
        )
    else
        return (
            <Fragment></Fragment>
        )

}


export default UmbracoReusableGrid
